import React, { useState } from "react";
import { Row, Col, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import megaMenuData from "../data/menuData";

const MegaMenuMenu1 = ({ setShowMegaMenu }) => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (index) => {
    setOpenSections((prev) => ({
      [index]: !prev[index] || false,
    }));
  };

  return (
    <Row className="px-3">
      {megaMenuData.map((section, index) => {
        const isOpen = openSections[index];

        return (
          <Col
            key={index}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={2}
            className={`px-3 my-2 ${isOpen ? "section-open" : ""}`}
          >
            <SectionHeader
              title={section.title}
              icon={section.icon}
              isOpen={isOpen}
              onClick={() => toggleSection(index)}
              className={isOpen ? "active-header" : ""}
              to={section.to}
              setShowMegaMenu={setShowMegaMenu}
            />

            {/* Mobile: Show content only if open */}
            <div className="d-md-none ps-3">
              {isOpen && renderSectionContent(section, setShowMegaMenu)}
            </div>

            {/* Desktop: Always show */}
            <div className="d-none d-md-block ps-3">
              {renderSectionContent(section, setShowMegaMenu)}
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

const SectionHeader = ({
  title,
  icon,
  isOpen,
  onClick,
  className,
  to,
  setShowMegaMenu,
}) => {
  const titleContent = (
    <span className="d-flex align-items-center">
      {icon && <span className="me-2">{icon}</span>}
      <span
        className="bics-ai-title"
        style={{ fontSize: "14px", fontWeight: "700" }}
      >
        {title}
      </span>
    </span>
  );

  return (
    <button
      className={`d-flex justify-content-between align-items-center w-100 py-2 px-2 bg-transparent border-0 text-start ${className}`}
      style={{ borderBottom: "1px solid #cdcdcd", cursor: "pointer" }}
      onClick={onClick}
    >
      {to ? (
        <LinkContainer to={to}>
          <Nav.Link
            className="p-0 m-0"
            onClick={(e) => {
              e.stopPropagation(); // prevent toggle click
              setShowMegaMenu(false);
            }}
          >
            {titleContent}
          </Nav.Link>
        </LinkContainer>
      ) : (
        titleContent
      )}
      <span className="d-md-none ms-2">{isOpen ? "⏶" : "⏷"}</span>
    </button>
  );
};

const renderSectionContent = (section, setShowMegaMenu) => {
  return section.groups ? (
    section.groups.map((group, gi) => (
      <div key={gi} className="mt-1 mt-md-3">
        {group.groupTitle && (
          <div className="text-muted small fw-bold mb-2 ps-2">
            {group.groupTitle}
          </div>
        )}
        <MenuList items={group.items} setShowMegaMenu={setShowMegaMenu} />
      </div>
    ))
  ) : (
    <MenuList items={section.items} setShowMegaMenu={setShowMegaMenu} />
  );
};

const MenuList = ({ items, setShowMegaMenu }) => (
  <ul className="mt-2 px-0 menu-linkz">
    {items.map((item, i) => {
      let label = item;
      let description = null;
      let icon = null;
      let to = null;

      if (typeof item === "object") {
        label = item.label;
        description = item.description;
        icon = item.icon;
        to = item.to;
      }

      const content = (
        <div className="d-flex align-items-start ps-2">
          {icon && <span className="me-2">{icon}</span>}
          <div>
            <div className="fw-medium">{label}</div>
            {description && (
              <div className="small text-muted">{description}</div>
            )}
          </div>
        </div>
      );

      return (
        <li key={i} className="my-1 mid-nav-font">
          {to ? (
            <LinkContainer to={to}>
              <Nav.Link onClick={() => setShowMegaMenu(false)}>
                {content}
              </Nav.Link>
            </LinkContainer>
          ) : (
            <Nav.Link>{content}</Nav.Link>
          )}
        </li>
      );
    })}
  </ul>
);

export default MegaMenuMenu1;
